import { useEffect, useState } from "react";
import useApi from "./useApi";

interface NetSuiteConfig {
  id: number;
  displayName: string;
  company: string;
  teamId: number;
}

export default function useNetSuiteConfigs(teamId: number) {
  const [items, setItems] = useState<NetSuiteConfig[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      const resp = await api.messaging.get(`NetSuite/Integrations/`);
      setItems(await resp.json());
      setLoading(false);
    }

    fetchConfigs();
  }, [api.messaging]);

  return { items, loading };
}
